import React from 'react';

export default function Header(props) {

  return (
    <div className='personal-area-invoices-header'>
      <div className="ellipse"></div>
      <h1>היי, {props.customerName}</h1>
      <h2>החשבוניות שלך</h2>
    </div>
  );
}

